export default [

    // *===============================================---*
    // *--------- Calender - Marketing  ---------------------------------------*
    // *===============================================---*
    {
        path: '/marketing/plan/calender',
        name: 'marketing-plan-calender',
        component: () => import('@/views/marketing/calendar/Calendar.vue'),
        meta:{
            pageTitle:'Marketing Plan',
            breadcrumb: [
                {
                    text: 'Marketing Plan',
                    active:true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },
    // *===============================================---*
    // *--------- Blog List Campaign - Marketing  ---------------------------------------*
    // *===============================================---*
    {
        path: '/marketing/campaign/list',
        name: 'marketing-campaign-list',
        component: () => import('@/views/marketing/campaign/campaigns.vue'),
        meta: {
            pageTitle: 'Marketing Feed',
            breadcrumb: [
                {
                    text: 'Marketing Campaign',
                    active: true,
                },
              
            ],
            permission: 'Permissions.Marketing.View'
        },
        
    },

    {
        path: '/marketing/blog/list',
        name: 'marketing-blog-list',
        component: () => import('@/views/marketing/blog/BlogList.vue'),
        meta: {
            pageTitle: 'Marketing Feed',
            breadcrumb: [
                {
                    text: 'Marketing Campaign',
                    active: true,
                },
              
            ],
            permission: 'Permissions.Marketing.View'
        },
        
    },

    // *===============================================---*
    // *--------- Blog Add Content - Marketing  ---------------------------------------*
    // *===============================================---*

    {
        path: '/marketing/campaign/add',
        name: 'marketing-blog-add',
        component: () => import('@/views/marketing/campaign/AddMarketingCampaign.vue'),
        meta: {
            pageTitle: 'Marketing Add Campaign',
            breadcrumb: [
                {
                    text: 'Marketing Campaign',
                    to: '/marketing/campaign/list',
                },
                {
                    text: 'Add Campaign',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    // *===============================================---*
    // *--------- Edit Campaign - Marketing  ---------------------------------------*
    // *===============================================---*

    {
        path: '/marketing/campaign/edit/:id',
        name: 'marketing-draft-edit',
        component: () => import('@/views/marketing/campaign/EditCampaign/MarketingCampaignWizard.vue'),
        meta: {
            pageTitle: 'Marketing Edit Draft',
            breadcrumb: [
                {
                    text: 'Marketing Campaign',
                    to: '/marketing/campaign/list',
                },
                {
                    text: 'Edit Campaign',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    // *===============================================---*
    // *--------- View Campaign - Marketing  ---------------------------------------*
    // *===============================================---*

    {
        path: '/marketing/campaign/view/:id',
        name: 'marketing-campaign-view',
        component: () => import('@/views/marketing/campaign/ViewCampaign/MarketingCampaignWizard.vue'),
        meta: {
            pageTitle: 'Marketing View Draft',
            breadcrumb: [
                {
                    text: 'Marketing Campaign',
                    to: '/marketing/campaign/list',
                },
                {
                    text: 'View Campaign',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },
    // *===============================================---*
    // *--------- CHAT - Marketing  ---------------------------------------*
    // *===============================================---*
    {
        path: '/marketing/chat',
        name: 'marketing-chat',
        component: () => import('@/views/marketing/chat/Chat.vue'),
        meta: {
            pageTitle: 'Marketing Chat',
            breadcrumb: [
             
                {
                    text: 'Conversations',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
    
          
        },
       
    },
 // *===============================================---*
    // *---------  Content Template- Marketing  ---------------------------------------*
    // *===============================================---*

   
    {
        path: '/content/templates',
        name: 'content-templates',
        component: () => import('@/views/marketing/template/main.vue'),
        meta: {
            pageTitle: 'Marketing Templates List',
            breadcrumb: [
                {
                    text: 'Marketing Templates List',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },



    {
        path: '/content/templates/add',
        name: 'content-template-add',
        component: () => import('@/views/marketing/template/add.vue'),
        meta: {
            pageTitle: 'Add Template',
            breadcrumb: [
                {
                    text: 'Content Templates',
                    to: '/content/templates',
                },
                {
                    text: 'Add Template',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    {
        path: '/content/templates/edit/:id',
        name: 'content-template-edit',
        component: () => import('@/views/marketing/template/edit.vue'),
        meta: {
            pageTitle: 'Edit Template',
            breadcrumb: [
                {
                    text: 'Content Templates',
                    to: '/content/templates',
                },
                {
                    text: 'Edit Template',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

    {
        path: '/content/templates/view/:id',
        name: 'content-template-view',
        component: () => import('@/views/marketing/template/view.vue'),
        meta: {
            pageTitle: 'View Template',
            breadcrumb: [
                {
                    text: 'Content Templates',
                    to: '/content/templates',
                },
                {
                    text: 'View  Template',
                    active: true,
                },
            ],
            permission: 'Permissions.Marketing.View'
        },
    },

]